import React, { useEffect, useMemo, useState } from "react";
import ReactGA from "react-ga4";

const ENV_DEPLOYED_AT =
  import.meta?.env?.VITE_DEPLOYED_AT ?? process.env.REACT_APP_DEPLOYED_AT;

export default function PaymentReminder({
  daysAfter = 7,
  title = "Billing Reminder",
  message = "Hi! 7 days have passed since deployment. Please arrange settlement. Thank you.",
}) {
  const [open, setOpen] = useState(false);

  const deployedAtMs = useMemo(() => {
    const iso = ENV_DEPLOYED_AT || new Date().toISOString();
    const t = new Date(iso).getTime();
    return Number.isNaN(t) ? 0 : t;
  }, []);

  useEffect(() => {
    if (!deployedAtMs) return;

    const now = Date.now();
    const due = deployedAtMs + daysAfter * 24 * 60 * 60 * 1000;

    if (now < due) return;

    setOpen(true);
    try {
      ReactGA.event("payment_reminder_shown");
    } catch {}
  }, [deployedAtMs, daysAfter]);

  if (!open) return null;

  return (
    <div className="pr-overlay" role="dialog" aria-modal="true">
      {/* Backdrop (non-clickable) */}
      <div className="pr-backdrop" />

      <div className="pr-modal">
        <h2 className="pr-title">{title}</h2>
        <p className="pr-msg">{message}</p>
      </div>
    </div>
  );
}